import classNames from 'classnames';
import Immutable from 'immutable';
import React from 'react';

import { getImagePathForCurrentBuild } from 'sharedreact/utils/BuildVersion';

type Props = {
  className?: string,
  large?: boolean,
  actionBar?: boolean,
  images: Immutable.List<string | null>,
  children?: React.ReactNode,
  maxRealImages?: number
};

type DefaultProps = Required<Pick<Props, 'large' | 'actionBar' | 'maxRealImages'>>;

type PropsWithDefaults = Omit<Props, keyof DefaultProps> & DefaultProps;

class PreviewTile extends React.Component<Props> {
  static defaultProps: DefaultProps = {
    large: false,
    actionBar: false,
    maxRealImages: 1
  };

  override render (): React.ReactNode {
    const { className, large, actionBar, images, children,
      maxRealImages
    } = (this.props as PropsWithDefaults);

    const divClassName = classNames(
      className,
      'esko_previewtile',
      { 'esko_previewtile-large': large },
      { 'esko_previewtile-with-actionbar': actionBar }
    );

    const noImageFile = getImagePathForCurrentBuild('noimage' + (large ? '-large' : '') + '.svg');

    const renderedPreviews = images.map((preview: string | null, index: number) => {
      const zIndex = images.size - index;
      const left = 2 + (large ? 80 : 40) / (images.size - 1) * index;
      const unFetchedPreview = !preview && (index >= maxRealImages);
      return (
        <div key={'multi_preview_' + index}
          className={classNames(
            'esko_previewimg-multi-div',
            { 'esko_previewtile-multi-div-large': large,
              'esko_previewimg-multi-img': unFetchedPreview }
          )}
          style={{zIndex: zIndex, left: left}}
        >
          { !unFetchedPreview &&
            <img src={preview || noImageFile}
              className='esko_previewimg-multi-img esko_previewimg' onError={(event) => (event.target as HTMLImageElement).src = noImageFile}
            />
          }
        </div>
      );
    });

    if (images.size <= 1) {
      const image = images.size > 0
                    ? images.get(0) || noImageFile
                    : noImageFile;
      return (
        <div className={divClassName}>
          <img src={image} className='esko_previewimg' onError={(event) => (event.target as HTMLImageElement).src = noImageFile} />
          <div className='esko_previewoverlay'>
            {children}
          </div>
        </div>
      );
    } else {
      return (
        <div className={divClassName}>
          <div className={classNames('esko_previewtile-multi', {'esko_previewtile-multi-large': large})}>
            {renderedPreviews.toArray()}
          </div>
          <div className='esko_previewoverlay'>
            {children}
          </div>
        </div>
      );
    }
  }
}

export default PreviewTile;
